// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"ps_a bhp_cw bhp_jx bhp_jo bhp_a bhp_j bhp_ri bhp_rj","SearchPanel__icon":"ps_b bhp_ui bhp_hb bhp_ro bhp_tu","SearchPanel__input":"ps_c bhp_iv bhp_cx bhp_z"};